<ng-container *transloco="let t">
    <ng-container *ngIf="!isFnb">
        <us-breadcrumbs *ngrxLet="homePageUrl$ as homePageUrl"
                        [items]="[
                { title: t('home'), routerLink: homePageUrl },
                { title: t('cart'), routerLink: undefined }
            ]">
        </us-breadcrumbs>
        <div class="flex flex-col h-full"
             [ngClass]="className">
            <div *ngIf="title"
                 class="px-4">
                <h4 class="text-gray-600">{{ title }}</h4>
            </div>
            <ng-container *ngIf="cart$ | async as cart">
                <div class="flex-auto overflow-y-auto no-scrollbar pt-2 flex flex-col gap-4 divide-y justify-between">
                    <us-order-items class="grid grid-cols-1 divide-y divide-gray-50"
                                    (quantityChanged)="onChangeItemQuantity($event)"
                                    [order]="cart"></us-order-items>

                    <div class="flex flex-col gap-4 py-4">
                        <div class="flex items-end justify-between">
                            <span class="font-semibold">
                                {{ 'subtotal' | transloco }} ({{ cart.total_items + ' ' + ('item' | transloco) }})
                            </span>
                            <span class="text-gray-500 mb-px font-semibold">
                                {{ cart.total_price || 0 | formatCurrency }}
                            </span>
                        </div>

                        <div class="flex items-end justify-between">
                            <span class="font-semibold"> {{ 'discount' | transloco }} </span>
                            <span class="text-gray-500 mb-px">
                                {{ cart.discount?.price || 0 | formatCurrency }}
                            </span>
                        </div>

                        <!-- <us-promotion-select></us-promotion-select> -->
                    </div>
                </div>
                <div class="flex-none border-t border-gray-200">
                    <div class="pt-4 flex flex-col gap-4">
                        <div class="flex items-end justify-between text-base">
                            <span>
                                <span class="font-semibold block">{{ 'total' | transloco }}</span>
                                <!--<span class="text-xs text-gray-500 mt-2 block">
                                    {{ 'tax_included_if_any' | transloco }}
                                </span>-->
                            </span>
                            <span class="font-semibold text-gray-900 block">
                                {{ cart.grand_total || 0 | formatCurrency }}
                            </span>
                        </div>

                        <ng-container *ngIf="isRetail()">
                            <ng-container *ngIf="paymentNotes$ | async as paymentNotes">
                                <div [innerHtml]="paymentNotes"
                                     class="mt-3 p-4 text-base bg-blue-50 text-gray-700 rounded block"></div>
                            </ng-container>
                        </ng-container>

                        <us-cart-checkout-btn *ngIf="isCartOwner()"
                                              [cart]="cart"></us-cart-checkout-btn>

                        <!-- <div class="pt-4" *ngIf="cart.current_state !== OrderState.Pending">
                            <us-order-actions [cart]="cart" [isLoading]="(loading$ | async) || false"></us-order-actions>
                        </div> -->
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="isFnb">
        <ng-container *ngIf="cart$ | async as cart">
            <div class="flex flex-col mt-4 px-1"
                 [ngClass]="className">
                <div class="card">
                    <div class="card-header">
                        <h5 class="card-title">{{ t('customer_info') }}</h5>
                    </div>
                    <div class="card-content">
                        <div class="flex flex-col gap-4 py-4">
                            <div class="flex items-center justify-between"
                                 *tuiLet="user$ | async as user">
                                <div class="info-customer"
                                     *ngIf="
                                        cart.order_type !== OrderType.OrderAtTheTable &&
                                        cart.order_type !== OrderType.TakeAway
                                    ">
                                    <p class="font-bold">{{ user?.name || 'Khách lẻ' | transloco }}</p>
                                    <p class="text-gray-500">
                                        <ng-container *ngIf="user?.name">
                                            {{ user?.name || '' }}
                                        </ng-container>
                                        <ng-container *ngIf="user?.phone"> - {{ user?.phone || '' }} </ng-container>
                                    </p>
                                </div>
                                <div class="info-customer"
                                     *ngIf="cart.order_type === OrderType.TakeAway">
                                    <p class="font-bold">{{ 'take_away' | transloco }}</p>
                                    <!-- <p class="text-gray-500">
                                        <ng-container *ngIf="user?.name">
                                            {{ user?.name || '' }}
                                        </ng-container>
                                        <ng-container *ngIf="user?.phone"> - {{ user?.phone || '' }} </ng-container>
                                    </p> -->
                                </div>
                                <div class="info-customer"
                                     *ngIf="cart.order_type === OrderType.OrderAtTheTable">
                                    <p class="font-bold">
                                        {{ cart.order_table?.area_name || '' }} - {{ cart.order_table?.name || '' }}
                                    </p>
                                    <!-- <p class="text-gray-500">
                                        <ng-container *ngIf="user?.name">
                                            {{ user?.name || '' }}
                                        </ng-container>
                                        <ng-container *ngIf="user?.phone"> - {{ user?.phone || '' }} </ng-container>
                                    </p> -->
                                </div>
                                <tui-svg src="svg::arrow-right"></tui-svg>
                            </div>
                            <div class="border-t border-gray-200"></div>
                            <div class="flex items-center justify-between"
                                 (click)="openNote = !openNote">
                                <div class="info-customer">
                                    <p>{{ 'note' | transloco }}</p>
                                    <p class="text-gray-500">{{ cart?.note || '' | transloco }}</p>
                                </div>
                                <tui-svg src="svg::arrow-right"></tui-svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card"
                     [ngClass]="className">
                    <div class="card-header">
                        <h5 class="card-title">{{ t('selected_product') }}</h5>
                        <button *ngIf="showAddItemButton()"
                                tuiButton
                                type="button"
                                size="s"
                                appearance="outline"
                                [icon]="'svg::plus'"
                                [routerLink]="'/'">
                            {{ t('add_items') }}
                        </button>
                    </div>
                    <div class="card-content">
                        <us-order-items class="grid grid-cols-1 divide-y divide-gray-50"
                                        (quantityChanged)="onChangeItemQuantity($event)"
                                        [order]="cart"></us-order-items>
                    </div>
                </div>
                <div class="card mb-5"
                     [ngClass]="className">
                    <div class="card-header">
                        <h5 class="card-title">{{ t('total') }}</h5>
                    </div>
                    <div class="card-content">
                        <div class="flex flex-col gap-4 py-4">
                            <div class="flex items-end justify-between">
                                <span class="font-normal">
                                    {{ 'subtotal' | transloco }} ({{ cart.total_items + ' ' + ('item' | transloco) }})
                                </span>
                                <span class="text-gray-500 mb-px">
                                    {{ cart.total_price || 0 | formatCurrency }}
                                </span>
                            </div>
                            <div class="border-t border-gray-200"></div>
                            <div class="flex items-end justify-between">
                                <span class="font-normal"> {{ 'discount' | transloco }} </span>
                                <span class="text-gray-500 mb-px">
                                    {{ cart.discount?.price || 0 | formatCurrency }}
                                </span>
                            </div>
                        </div>
                        <div class="flex-none border-t border-gray-200">
                            <div class="pt-4 flex flex-col gap-4">
                                <div class="flex items-end justify-between text-base">
                                    <span>
                                        <span class="font-semibold block">{{ 'total_payment' | transloco }}</span>
                                        <!--<span class="text-xs text-gray-500 mt-2 block">
                                                        {{ 'tax_included_if_any' | transloco }}
                                                    </span>-->
                                    </span>
                                    <span class="font-semibold text-gray-900 block">
                                        {{ cart.grand_total || 0 | formatCurrency }}
                                    </span>
                                </div>

                                <ng-container *ngIf="isRetail()">
                                    <ng-container *ngIf="paymentNotes$ | async as paymentNotes">
                                        <div [innerHtml]="paymentNotes"
                                             class="mt-3 p-4 text-base bg-blue-50 text-gray-700 rounded block"></div>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-container>
    <ng-template let-observer
                 [tuiDialogOptions]="{ label: t('note'), size: 's' }"
                 [(tuiDialog)]="openNote">
        <div class="flex justify-center flex-col">
            <tui-text-area class="w-full min-h-[10rem]"
                           [(ngModel)]="noteData"
                           [expandable]="true"
                           [maxLength]="100">
                {{ 'write_messages' | transloco }}
                <textarea tuiTextfield
                          maxlength="100"></textarea>
            </tui-text-area>

            <button tuiButton
                    size="m"
                    type="submit"
                    class="my-4"
                    (click)="saveNote()">
                {{ 'confirm' | transloco }}
            </button>
        </div>
    </ng-template>
</ng-container>